import type { ExistingDocument } from '@app/shared/types/sf-data'
import { DocumentLinkType } from '@app/shared/types/sf-data'
import type { Remark, Title } from '@app/application/communication/types'
import type { ExternalNote } from '@app/application/client_meetings/types'
import { isLink } from '@app/utils/url-helpers'

export const isRemark = (item: Remark | Title): item is Remark => {
  return (item as Remark).kind !== 'title'
}

export const isTitle = (item: Remark | Title): item is Title => {
  return (item as Title).kind === 'title'
}

export const toTypedId = (item: Remark | Title): string => {
  switch (item.kind) {
    case 'title':
      return `Title|${item.id}`
    case 'remark-card':
      return `Remark|${item.id}`
    default:
      throw new Error(`Unknown item kind: ${item?.kind}`)
  }
}

export async function getPageTitleViaBrowser(
  url: URL
): Promise<string | null | undefined> {
  const response = await fetch(url, { headers: { accept: 'text/html' } })

  if (!response.ok) {
    return null
  }

  const html = await response.text()
  const parsed = new DOMParser().parseFromString(html, 'text/html')
  const titleElement = parsed.querySelector('title')

  return titleElement?.textContent?.trim()
}

function isValidUrl(url: string): boolean {
  if (!url) {
    return false
  }

  return isLink(url, ['http', 'https'])
}

export function getValidUrl(url: string): string | undefined {
  if (isValidUrl(url)) {
    return url
  }

  if (isLink(url)) {
    return undefined
  }

  const httpsUrl = `https://${url}`

  if (isValidUrl(httpsUrl)) {
    return httpsUrl
  }
}

export function formatExistingDocument(
  uploadedDocument: ExternalNote
): ExistingDocument {
  return {
    document_id: uploadedDocument.id,
    linkType: DocumentLinkType.Document,
    name: uploadedDocument.name,
    unique_id: `document-${uploadedDocument.id}`,
    uploadedBy: uploadedDocument.uploadedBy,
    size: uploadedDocument.size,
  }
}
